"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _irrenderer = _interopRequireDefault(require("@fluke/irrenderer"));
var _pubSubMessageEnum = _interopRequireDefault(require("../enums/pubSubMessageEnum"));
var _OrientationEnum = require("../enums/OrientationEnum");
var _konva = _interopRequireDefault(require("konva"));
var _nodes = _interopRequireDefault(require("./konva/nodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var loadChain = function loadChain(classRef, PubSub) {
  return {
    StartLoadChain: function StartLoadChain() {
      classRef.debugLog(">>> loadChain_StartLoadChain"); // Clear the stage is necessary

      PubSub.publish(_pubSubMessageEnum.default.TOPIC_START_LOADIMAGE, null);
      if (classRef.is_loading) {
        return;
      }
      classRef.is_loading = true;
      if (classRef.imageLayer) {
        classRef.stageRef.current.destroyChildren();
        classRef.imageLayer = null;
        classRef.irImageRef = null;
        classRef.visualImageObject = null;
        classRef.tooltipRef = null;
        classRef.imageInfo = null;
        classRef.ir_array_data = null;
        classRef.vl_array_data = null;
        classRef.previewImage = null;
      }
      if (classRef.markerLayer) {
        classRef.stageRef.current.destroyChildren();
        classRef.markerLayer = null;
      }
      loadChain_CreateStage();
    }
  };
  function loadChain_CreateStage() {
    classRef.debugLog(">>> loadChain_CreateStage");
    classRef.imageLayer = new _konva.default.Layer({
      name: "image"
    });
    classRef.markerLayer = new _konva.default.Layer({
      name: "markers"
    });
    classRef.stageRef.current.add(classRef.imageLayer);
    classRef.stageRef.current.add(classRef.markerLayer);
    classRef.imageLayer.clip({
      x: 0,
      y: 0,
      width: classRef.stageWidth,
      height: classRef.stageHeight
    });
    classRef.markerLayer.clip({
      x: 0,
      y: 0,
      width: classRef.stageWidth,
      height: classRef.stageHeight
    });
    classRef.stageRef.current.scale({
      x: classRef.frameWidth / classRef.stageWidth,
      y: classRef.frameHeight / classRef.stageHeight
    });
    loadChain_ShowPreview();
  }
  function loadChain_ShowPreview() {
    classRef.debugLog(">>> loadChain_ShowPreview ");
    if (classRef.previewImagePayload === null || classRef.previewImagePayload === undefined) {
      loadChain_StartIRModuleLoad();
    }
    if (classRef.shouldRenderImages !== false) {
      if (classRef.previewImagePayload.byteLength === 0) {
        loadChain_StartIRModuleLoad();
      } else {
        var blob = new Blob([classRef.previewImagePayload], {
          type: "image/jpeg"
        });
        var url = URL.createObjectURL(blob);
        _konva.default.Image.fromURL(url, function (image) {
          classRef.previewImage = image;
          image.width(classRef.stageWidth);
          image.height(classRef.stageHeight);
          classRef.imageLayer.add(image);
          classRef.stageRef.current.draw();
          loadChain_StartIRModuleLoad();
        });
      }
    } else {
      loadChain_StartIRModuleLoad();
    }
  }
  function loadChain_StartIRModuleLoad() {
    classRef.debugLog(">>> loadChain_StartIRModuleLoad");
    classRef.renderer = new _irrenderer.default("/irrenderer.wasm", function (args) {
      return loadChain_CompleteIRModuleLoad(args);
    });
  }
  function loadChain_CompleteIRModuleLoad(args) {
    classRef.debugLog(">>> loadChain_CompleteIRModuleLoad");

    // TODO: return completion boolean, else throw step error
    loadChain_LoadAllUrls();
    loadChain_LoadImageInfoData();
    // render canvas
    loadChain_RenderInitialImages();
    loadChain_CompleteSetupTooltip();
    loadChain_CompleteLoadChain();
    loadChain_LoadIRViewerConfig();
  }
  function loadChain_LoadAllUrls() {
    classRef.debugLog(">>> loadChain_LoadAllUrls");
    var resultPayloads = [classRef.imageInfoPayload, classRef.irDataImagePayload, classRef.visualImagePayload, classRef.previewImagePayload];
    classRef.debugLog(">>> loadChain_CompleteLoadAllUrls");
    classRef.imageInfo = JSON.parse(JSON.stringify(resultPayloads[0])); // Force a copy be made.

    classRef.ir_array_data = resultPayloads[1] !== undefined ? new Uint8Array(resultPayloads[1]) : null;
    classRef.vl_array_data = resultPayloads[2] !== undefined ? new Uint8Array(resultPayloads[2]) : null;
    if (classRef.ir_array_data !== null && classRef.vl_array_data !== null) {
      classRef.renderer.irrenderer_init_buffers(JSON.stringify(classRef.imageInfo), classRef.ir_array_data, classRef.vl_array_data);
    }
  }
  function loadChain_LoadImageInfoData() {
    classRef.debugLog(">>> loadChain_LoadImageInfoData");
    // destructure values from thermal image info
    var thermalImageInfo = classRef.imageInfo.THERMAL_IMAGE_INFO_DATA_VGPB;
    var basicPresentationFlags = thermalImageInfo.basicPresentationFlags,
      irPaletteSetup = thermalImageInfo.irPaletteSetup;

    // set initial state of the irviewer
    classRef.setState({
      dirty_number: 0,
      pipMode: basicPresentationFlags.pipMode ? 1 : 0,
      temperatureUnits: basicPresentationFlags.presentationTempUnits,
      irAlpha: basicPresentationFlags.irAlphaLevel,
      paletteScheme: irPaletteSetup.paletteScheme,
      paletteScaleMode: irPaletteSetup.paletteScaleMode,
      rangeMin: irPaletteSetup.paletteRangeMinTempC,
      rangeMax: irPaletteSetup.paletteRangeMaxTempC,
      rotation: (0, _OrientationEnum.indexToRotation)(irPaletteSetup === null || irPaletteSetup === void 0 ? void 0 : irPaletteSetup.irOrientation),
      emissivity: thermalImageInfo.capturedEmissivity,
      backgroundTemp: thermalImageInfo.capturedBackgroundTempC,
      transmission: thermalImageInfo.capturedTransmissionFactor
    });
  }
  function loadChain_RenderInitialImages() {
    classRef.debugLog(">>> loadChain_RenderInitialImages");
    if (classRef.shouldRenderImages !== false) {
      classRef.updateLayers.push(function () {
        return classRef.updateVisualLayer();
      });
      classRef.updateLayers.push(function () {
        return classRef.updateIRLayer();
      });
      classRef.updateLayers.push(function () {
        return classRef.updateMarkerLayer();
      });

      // magic wand
      var wand = false;
      if (wand === false) {
        // default
        classRef.renderer.irrenderer_render_to_images(JSON.stringify(classRef.imageInfo));
      } else {
        // clears the current user markers in the event of contaminated json
        var newObject = _objectSpread({}, classRef.imageInfo);
        newObject.MARKERS.USERDEFINED = {};
        classRef.renderer.irrenderer_render_to_images(JSON.stringify(newObject));
      }
      classRef.render_result_json = classRef.renderer.irrenderer_rendering_get_output_data();
      classRef.updateLayers.forEach(function (func) {
        return func();
      });
      classRef.updateLayers = [];
      PubSub.publish(_pubSubMessageEnum.default.TOPIC_COMPLETE_LOADIMAGE, null);
    }
  }
  function loadChain_CompleteSetupTooltip() {
    classRef.debugLog(">>> loadChain_CompleteSetupTooltip");
    if (classRef.shouldRenderImages !== false) {
      var tooltip = _nodes.default.label({
        text: "",
        padding: 5,
        alpha: 0.75,
        visible: false
      });
      classRef.tooltipRef = tooltip;
      classRef.imageLayer.add(classRef.tooltipRef);
    }
  }
  function loadChain_LoadIRViewerConfig() {
    // load config form irviewer options
    var irViewerOptions = classRef.GetBaseEditorOptionsRoot();
    var _ref = irViewerOptions || {},
      globalMarkerVisible = _ref.globalMarkerVisible;
    classRef.setState({
      globalMarkerVisible: globalMarkerVisible
    });
  }
  function loadChain_CompleteLoadChain() {
    classRef.debugLog(">>> loadChain_CompleteLoadChain");
    if (classRef.shouldRenderImages !== false) {
      classRef.stageRef.current.show();
    }
    if (classRef.state.loaded === false) {
      classRef.updateState({
        loaded: true
      });
    }
    if (classRef.shouldRenderImages !== false) {
      classRef.stageRef.current.draw();
    }
    if (classRef.shouldRenderImages !== false && classRef.previewImage) {
      classRef.previewImage.destroy();
    }
    classRef.is_loading = false;
    if (classRef.shouldRenderImages !== false) {
      loadChain_UpdateMarkersAfterLoad();
    }
    if (classRef.loadedCallback != null) {
      classRef.loadedCallback(classRef);
    }
  }
  function loadChain_UpdateMarkersAfterLoad() {
    if (!classRef.GetBaseEditorOptionsRoot().hasOwnProperty("MarkerOrdering")) {
      var marker_name_id = {};
      var markers = classRef.AllUserDefinedMarkers();
      for (var _i = 0, _Object$keys = Object.keys(markers); _i < _Object$keys.length; _i++) {
        var marker_key = _Object$keys[_i];
        var marker = markers[marker_key];
        marker_name_id[marker.characteristics.markerName] = marker.characteristics.uniqueIDString;
      }
      classRef.GetBaseEditorOptionsRoot()["MarkerOrdering"] = [];
      var sorted_names = Object.keys(marker_name_id).sort();
      sorted_names.forEach(function (current_name) {
        classRef.GetBaseEditorOptionsRoot().MarkerOrdering.push(marker_name_id[current_name]);
      });
    }
  }
};
var _default = exports.default = loadChain;